// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1O194","label":"Labeled_label__ywAjI","divider":"Labeled_divider__2aJGD"};